import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './MyPage.css';
import './MyPageExtend.css';
import consumerRightsUrl from '../消费者权益保障与处理办法.txt';
import { services } from './servicesData';

const phoneReg = /^1[3-9][0-9]{9}$/;

// 用户协议内容
const USER_AGREEMENT_CONTENT = `用户协议更新时间：2025年7月10日尊敬的用户您好！在注册、登录、使用"益美科技家政服务平台"网站前（以下简称"平台"或"本平台"），请您认真阅读并充分理解《用户协议》（以下简称"本协议"）和《隐私政策》中的各条款。"益美科技家政服务平台"网站是由成都益美美佳网络科技有限公司运营团队运营。用户（以下简称"您"或"用户"）承诺在仔细阅读和完全接受《用户协议》（以下简称"本协议"或"协议"）项下全部条款的基础上使用本平台的各项服务。用户接受本协议点击"同意"或"同意并注册"按钮或其他类似意思表示完成注册即表示完全接受以上述及的所有条款。请您审慎阅读并选择接受或不接受本协议。如果您不接受，请您立刻停止使用本平台。本协议对与您的权益有或可能具有重大关系的条款，及对本平台具有或可能具有免责或限制责任的条款用粗体字予以标注，请您重点阅读。一、协议的确认及修订1.1 本协议内容包括协议正文、以及本平台公布的其他协议、规范、规则、声明、须知、公告、政策等（以下统称"平台规则"）。平台规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。除另行明确声明外，用户注册、登录本平台及使用本服务的行为将受到本协议的约束。1.2 如果用户对本协议的任何条款表示异议，或者无法准确理解本协议，应向本平台咨询；用户注册、登录本平台、使用本服务等行为则意味着用户同意遵守本协议下全部规定。1.3 基于互联网服务的及时性、复杂性、高效性等特性及监管要求、政策调整等原因，您同意本平台可不定期更新本协议及平台规则，用户可以在本平台查阅最新协议和/或规则。更新后的协议和/或规则一经公布即生效，且自动取代原来的协议和/或规则。协议和/或规则更新后，如用户不同意接受更新后的协议和/或规则，用户应立即停止登录和使用本平台，若您选择更新后继续使用本平台服务，则视为您已接受更新后的内容，若发生有关争议时，以最新的条款为准。二、账号注册及登录2.1 用户在使用本服务前需注册、登录平台账号，用户在申请注册账号时应当是年满18周岁的具备完全民事权利能力和完全民事行为能力的自然人。本平台禁止未满8周岁的未成年人（包括其他无民事行为能力人）注册、登录和/或使用本平台服务。若您是8周岁以上未满18周岁（包括其他限制民事行为能力人），请在法定监护人的陪同下阅读本协议及相关平台规则，您注册和/或购买、使用本平台提供的服务前应当获得法定监护人的同意。本平台将有权根据用户提供的个人信息判断用户是否年满8周岁和/或18周岁。本平台并无能力对您和/或您的法定监护人的民事权利能力和民事行为能力进行实质性审查，因此如果您阅读并同意了本协议，且在本平台明确提示后，您仍然进行了注册和/或购买、使用本平台服务的行为，则视为该等行为已经取得了您的法定监护人的同意，本协议及平台规则即对您和/或您的法定监护人产生法律约束力，您注册、使用本平台服务的行为应当产生法律效力，您应当承担与之相关的法律责任。2.2用户在使用本平台时由平台默认生成用户唯一平台账号，平台账号应当使用手机号码绑定注册，请用户使用尚未与本平台账号绑定的手机号码，以及未被本平台根据本协议封禁的手机号码注册平台账号。2.3用户理解并同意，用户在本平台进行账号登录时，为提升用户的使用体验及为用户提供便捷的服务，未经注册的手机号码首次登录即完成注册。2.4用户同意并理解为了提供用户的产品体验本平台可以根据用户需求或产品需要对账号注册和绑定的方式进行变更，而无须事先通知用户。    2.5如果注册申请者有被本平台封禁的先例或涉嫌虚假注册及滥用他人名义注册，及其他不能得到许可的理由，平台将拒绝其注册申请。三、账号的安全管理3.1 为保护用户的账号安全及维护用户的合法权益，您同意并授权在法律法规允许的范围内，用户同意其账号的所有权归本平台所有，用户完成注册后获得其账号的使用权。该使用权仅属于初始申请注册人，禁止赠与、借用、租用、转让或售卖。平台因经营需要，有权回收用户的平台账号。用户知悉和同意账号的唯一性和不可转让性，因此，用户注册的账号仅限于注册人本人使用，禁止以赠与、借用、租用、转让或售卖等任何方式提供给他人使用，若用户违反本条约定，所造成的的损失由您独自承担。3.2 用户可以更改、删除平台帐户上的个人资料、注册信息及传送内容等，但需注意，删除有关信息的同时也会删除用户储存在系统中的文字和图片。用户需自行承担该风险。3.3 用户有义务采取各种措施保管好自己的账号安全，并对账号的所有行为和事件尽到合理注意义务。如果用户未保管好自己的账号和密码而对用户、本平台或第三方造成的损害，用户将自行承担全部责任。3.4用户有责任妥善保管注册账号信息及账号密码的安全，因用户保管不善可能导致遭受盗号或密码失窃，责任由用户自行承担。3.5 用户若发现任何非法使用账号或账号安全漏洞的情况，有义务立即通知本平台，本平台将在合理的范围内保障用户的权益。3.6为保护您的合法权益您知悉并同意，若本平台发现使用者并非账号注册人及/或账号存在异常登录且账号被盗取的可能性较大，用户同意本平台有权不经您的授权，直接冻结、收回账号而无需向账号使用人、注册人承担法律责任，由此带来的包括但不限于通讯中断、资料和虚拟财产清空等损失由账号使用人、注册人自行承担。四、关于本服务  4.1您在使用本平台前请您仔细了解本平台为您提供的服务内容，特别是您在使用本平台服务时请您慎重抉择。 4.2您理解并同意，因市场行情的变化，可能导致本平台商品价格、数量、介绍、等商品信息随时都有可能发生变动，任何变动本平台均不作特别通知，请您至商品页面自行查看。平台会尽最大努力保证您所浏览的商品信息的准确性；但由于商品种类繁多、商品信息的数量较大以及互联网技术因素等客观原因，商品信息页面显示可能会有一定的滞后性或差错，您对此表示知悉和理解。 4.3您知悉并同意为提供用户的产品体验，平台在遵守相关法律法规前提下，根据合作广告主的要求，本平台有权決定用户在平台应用界面上看到的广告内容及发布方式。若您通过点击平台内的广告进行的消费、下载、使用等情形造成您的个人经济损失及其他损失与本平台无关，本平台不承担任何违约赔偿责任及其他相关责任。 4.4 您理解盲盒属于特殊商品，盲盒类产品无论是实物商品还是虚拟商品都不支持七天无理由退货，若有严重的质量问题导致产品无法使用，您可以通过平台客服进行反馈，本平台会根据实际情况来处理，若您不同意本条款，请您退出使用本平台，您继续使用则视为您同意并接受本条款及本协议的约束。4.5 本平台可能因营销活动、产品推广等各种原因，在特定时期内推出"限时免费"、"限量优惠"以及赠送服务等优惠措施（以下统称"优惠措施"），您理解并同意，这些优惠措施可能是暂时性、阶段性或有数量限制的，也可能仅适用于满足特定条件的客户，您需要按照相应的规则购买、使用相应服务。4.6 本平台服务包括广告，您理解并同意在使用本平台服务过程中平台及其关联方或第三方合作伙伴可向您发布或向您的电子设备发送广告信息。支付5.1当您选择您喜欢的盲盒下单时，请您审慎思考，完成支付则视为您已阅读、理解，并接受本协议及平台规则的约束。5.2您在提交订单购买时，请仔细确认所购盲盒的商品名称、商品种类、商品样式、抽取规则、商品分布、隐藏款抽取概率、商品价值范围等信息。您需在平台内提供您的真实收货信息包括但不限于收货人姓名、联系电话、收货地址等信息。若收货人并非您本人，收货人的行为和意思表示将视为您的行为和意思表示，您应对收货人的行为及意思表示产生的法律后果承担连带责任，您提交订单即表示对订单中所确认的订单、收货信息等内容的准确性负责。如果因为您填写的收货人姓名、联系电话、收货地址等信息错误，导致延期配送、不能配送、或商品交付给非您本意的收货人的，由此造成的损失需由您自行承担；因此造成任何损失或增加费用的，应由您完全独自承担。5.3如果用户支付账户在购买时金额出现错误，用户可以自出现错误之日起7个工作日以内与本平台官方客服联系。5.4如果用户采用擅自更改本应用程序使得该潜在用户虽然安装了本平台，但没有正常使用行为的或使用黑客手段攻击本平台服务器等不正当手段来获取账户余额，本平台视为用户作弊行为而有权取消该用户资格并删除该用户所有账户余额，并保留对攻击本平台服务器等黑客行为追究法律责任的权利。5.5我们非常重视对未成年人（包括其他无民事行为能力人及限制民事行为能力）的保护，本平台禁止未满8周岁的未成年人（包括其他无民事行为能力人）消费。若您是8周岁以上18周岁以下的未成年人（包括其他限制民事行为能力），在本平台消费前，应事先取得您的法定监护人的同意。如果您阅读并同意了本协议及相关平台规则，且在平台明确提示后，您仍然进行了消费行为，则视为您已经取得了法定监护人的同意，您的消费行为应当产生法律效力，您应当承担与之相关的法律责任。5.6 8周岁以上18周岁以下的未成年人（包括其他限制民事行为能力）的消费行为需由法定监护人陪同并监管，平台不接受以"未成年人（包括其他无民事行为能力人及限制民事行为能力）自行充值消费"等具有不可控、不可证性质的理由提出的退款要求，如有疑问请提供针对未成年人（包括其他无民事行为能力人及限制民事行为能力）消费行为未得到合理监管的相关证明，并积极配合平台处理。六、发货规则 6.1购买后商品将进入"仓库"，用户可自行查看；用户选择提货后，填写准确的收货信息，我们将在7个工作日内为您发货；绑定手机号、关注公众号：本平台服务号，以便接收即将过期提醒和物流查询等。6.2用户提货、购买或使用锦鲤币兑换商品时，需据实支付运费，运费会因收货地区、发货时间等情况的不同而有所不同，部分可能涉及运费减免的运营活动请以相关活动公告或订单页面为准；港澳台不支持配送。6.3您理解并同意，因疫情、极端天气、库存等不可抗力因素造成的延迟/不能发货等情况，本平台不承担任何责任。具体的发货时间等信息请查看平台内的公告或订单页面。七、售后 7.1"盲盒"类产品不支持七天无理由退换货及退款。7.2商品一经发出，您拒绝签收的，需由您承担商品毁损、灭失的风险及因此产生的相关费用。7.3"盲盒"类产品具有随机性的特点，您在充值购买平台上某一"盲盒"产品后，平台随机开出您所得商品与您实际收到的商品一致，多次购买同一系列产品可能使您收到多款重复的商品，开出重复商品不属于售后范围内，我们也建议您理性消费，用户对此完全了解并接受，且不持任何疑义。7.4由于灯光、设备、显示器分辨率等因素，商品图片恐有色差，商品实际颜色请以实物为准；原厂瑕疵（见商品详情页面规则须知）、暴力快递、非可控客观因素（包括但不限于自然灾害、政府行为等）等均不属于售后范围。7.5如遇外箱严重破损等情况请拒签，缺件、断裂、发错等严重商品质量问题，请您在收到商品后的7天内明确商品问题并联系客服处理售后，7天后将不再接受任何售后处理。7.6售后范围：发错、缺件、断件、严重瑕疵等非人为故意损坏的情况；举证要求：证明问题的照片/视频或其他能够证明非人为故意的证据。7.7因质量问题的售后处理流程，您需要在商品物流签收后7天内联系客服申请退换货.如果商品符合退换货条件且库存充足，本平台将优先为您提供换货服务；如商品无库存，本平台将为您提供退货服务，退换货运费由本平台承担；部分需要品牌方售后的，本平台将为您提供售后途径。品牌方可提供售后范围为（部件换新/整件换新/修复），处理时效以品牌方通知为准。本平台会根据您提供的证据进行判断，您应对证据的真实性、关联性、完整性、准确性和及时性负责。退货商品寄回后，本平台签收商品前的风险由您承担，您应在规定的退货时间内申请退换货，并在被通知可寄回起3天内将商品寄回并提供物流单号至本平台在线客服。您因超时寄出商品的，对同一问题或维权原因再次主张要求退货的，本平台有权不予处理。八、用户使用规范8.1本平台用户不能利用本平台的账号或提供的服务进行如下行为：8.1.1用户擅自更改、消除或毀损本平台广告业务提供的各种信息；8.1.2利用技术手段批量建立虚假账号；8.1.3侵害本平台以及第三者的知识产权；8.1.4提交、发布虚假信息，或盗用他人资料，冒充、利用他人名义；8.1.5未经本平台许可，传播广告或淫秽、暴力等信息；8.1.6其他不遵守本协议的行为；8.1.7其他违法以及不正当的行为。8.2除非法律允许或经本平台书面许可，用户使用本平台过程中不得从事下列行为：8.2.1删除本平台及其副本上关于著作权的信息；8.2.2对本平台进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本平台的源代码；8.2.3对本平台拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、发立镜像站点等；8.2.4对本平台或者本平台运行过程中释放到任何终端内存中的数据、平台运行过程中客户端与服务器端的交互数据，以及本平台运行所必需的系统数据，进行复制，形式包括但不限于使用插件、外挂或非本平台经授权的第三方工具/服务接入本平台和相关系统；8.2.5通过修改或伪造平台运行中的指令、数据，增加、删减、变动平台的功能或运行效果，或者将用于上述用途的平台、方法进行运营或向公众传播，无论这些行为是否为商业目 的；8.2.6通过非本平台开发、授权的第三方平台、插件、外挂、系统，登录或使用本平台平台及服务，或制作、发布、传播上述工具8.2.7自行或者授权他人、第三方平台对本平台及其组件、模块、数据进行干扰；8.2.8其他未经本平台明示授权的行为。九、服务的变更、中断、终止9.1因设备维修或更换、故障和通信中断等技术原因以及其他不能预见、不能克服、不能避免且对本平台提供服务造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、风暴等以及社会事件如战争、动乱、政府行为等（以下简称"不可抗力"）而中断业务，本平台可视情况事前或事后通知用户，由此引发的损害及后果，对此本平台不承担任何责任。9.2本平台临时中断业务时将在本平台网站中公告。9.3如果因本平台自身业务发展情况变更致使服务终止，具体规则及处理以平台公告为准。因不可抗力导致的业务中断/终止发生时，本平台不给予用户补偿，用户对此完全了解并接受，且不持任何疑义。9.4当本平台用户发生如下情况之一时，本平台可单方面终止本协议：a.用户死亡；b.盗用他人的个人信息或手机号；c.注册用户时提供虚假信息；d.以非法手段（包括且不限于黑客攻击、利用系统技术bug等）来积累或使用账户余额；e.妨碍其他用户的正常使用；f.伪称是本平台的工作人员或管理人员；g.擅自强行更改本平台的计算机系统，或威胁侵入系统；h.擅自传播谣言，用各种手段来毀损本平台的名誉与妨碍本平台的正常运营；i.利用本平台的产品及服务宣传垃圾广告；j.其他违反本协议的行为及违法、犯罪行为。十、知识产权保护成都益美美佳网络科技有限公司是本平台的知识产权权利人。本平台的商标、著作权、专利权、商业秘密、广告业务以及所提供的有关广告内容，以及与本平台和服务相关的所有信息内容（包括但不限于文字图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）的知识产权都归属于本平台。用户不经本平台的许可不能擅自（包括但不限于）使用、复制、发布、转载、汇编、修改、发表与出版上述知识产权，或通过其他途径获取任何收益等。十一、免责条款    11.1本平台提供的服务中包括广告，用户同意在使用过程中显示本平台与第三方供应商、合作伙伴提供的广告。除法律法规明确规定外，用户应自行对依该广告信息进行的交易负责，对用户因依该广告信息进行的交易或前述广告商提供的内容而遭受的损失或损害，本平台不承担任何责任，由交易双方按照法律规定自行处理和解。    11.2由于商品的特殊属性，本平台不支持7天无理由退换货条款，售后服务期限为7天，期满后本平台对此将不再作任何处理，并不承担任何责任。    11.3"盲盒"类产品具有随机性的特点，对此您已充分了解。您应该自行承担您在本平台平台进行充值的一切后果，并对您在本平台账户下的一切消费行为负责。对此，您不应以未收到特定款式的商品为由要求本平台退款、赔偿或承担任何责任。本平台无法且不会对因前述问题而导致的任何损失或损害承担责任。    11.4用户理解并同意，因用户违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，用户应当独立承担责任；本平台因此遭受损失的，用户应对本平台予以赔偿。    11.5用户理解并同意，用户下载安装的其他平台或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，威胁用户的终端设备信息和数据安全，继而影响本平台的正常使用等。因此，用户应加强信息安全及个人信息的保护意识，注意密码保护，以免遭受损失。    11.6用户在使用本平台及服务时，须自行承担如下来自本平台不可掌控的风险内容，包括但不限于：    a.由于不可抗拒因素可能引起的个人信息丢失、泄漏等风险；    b.用户必须选择与所安装终端设备相匹配的平台版本，否则，由于平台与终端设备型号不相匹配所导致的任何问题或损害，均由用户自行承担；    c.用户在使用本平台访问第三方网站时，因第三方网站及相关内容所可能导致的风险，由用户自行承担；    d.用户发布的内容被他人转发、分享，因此等传播可能带来的风险和责任；e.由于无线网络信号不稳定、无线网络带宽小等原因，所引起的登录失败、资料同步不完整、页面打开速度慢等风险。11.7用户理解并同意了解本平台平台并非产品的制造、加工、出售方，通过使用本平台开出的产品均由本平台合作的第三方供应商提供，若因商品给您带来损失，本平台可以协助您维权，但本平台不承担任何责任。若您不同意本条款，请您立即停止使用本产品/本平台，您继续使用则视为您同意并接受本条款、本协议、本平台的约束。通知和送达12.1 您应当保证和维持客户资料（包括但不限于电话号码、电子邮箱、联系地址等联系方式）的有效性，客户资料若存在虚假、无效等任何可能导致您无法及时获悉业务通知、服务提示、客户服务、技术支持、纠纷协调、违规处罚等信息的，由您自行承担相应责任。12.2 本平台可通过网页公告、系统通知、站内信、电子邮件、手机短信、即时通讯工具、函件等方式中的一种或多种向您发送与本平台服务有关的业务通知、服务提示、验证消息、营销信息等各种信息（包括但不限于更新后的服务规则、服务升级、广告等）。前述信息在以下情况下视为已送达：12.2.1 交专人递送的，在收件人签收时视为已送达。12.2.2 以网页公告等形式公布的，一经公布即生效（另有说明除外）。12.2.3 以电子形式（包括系统通知、站内信、电子邮件、手机短信、即时通讯工具等）发送的，在发送成功后视为已送达。12.2.4 以邮资预付的快递公司递送或以挂号信递送的，以投邮后的第3个自然日视为已送达。如果送达时间为法定节假日的，则以送达后首个工作日为送达日。十三、其他13.1本平台郑重提醒用户注意本协议中免除本平台责任和限制用户权利的条款，请用户仔细阅读并充分理解本协议。13.2、本协议的效力、解释及纠纷的解決，适用于中华人民共和国法律。若用户和本平台之间发生任何纠纷或争议，首先应友好协商解，协商不成的，用户同意将纠纷或争议提交本平台运营方所在地人民法院管辖。13.3本协议的任何条款无论因何种原因无效或不具可执行性，其余条款仍有效，对双方具有约束力。13.4本协议的版权由成都益美美佳网络科技有限公司所有，本公司保留一切解释权。13.5本协议未明示授权的其他一切权利仍由本平台保留，用户在行使这些权利时须另外取得本平台的书面许可。本平台如果未行使前述任何权利，并不构成对该权利的放弃。13.6 本协议自在本平台上公示之日起生效。`;

const MyPage = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [showUserAgreementModal, setShowUserAgreementModal] = useState(false);
  // 消费者权益保障与处理办法
  const [showConsumerRightsModal, setShowConsumerRightsModal] = useState(false);
  const [consumerRightsContent, setConsumerRightsContent] = useState('');
  const [rightsLoading, setRightsLoading] = useState(false);
  const [rightsError, setRightsError] = useState('');

  // 新增功能状态
  const [showAboutModal, setShowAboutModal] = useState(false);
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [showFavoritesModal, setShowFavoritesModal] = useState(false);
  const [favorites, setFavorites] = useState([]);

  // 新增评价和预约功能状态
  const [showReviewsModal, setShowReviewsModal] = useState(false);
  const [showAppointmentsModal, setShowAppointmentsModal] = useState(false);
  const [showReviewFormModal, setShowReviewFormModal] = useState(false);
  const [currentReviewOrder, setCurrentReviewOrder] = useState(null);
  const [orders, setOrders] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [appointments, setAppointments] = useState([]);

  // 测试数据 - 为测试账号13300000000准备的数据
  const getTestData = () => {
    return {
      // 历史订单数据
      orders: [
        {
          id: 1,
          serviceName: '深度清洁',
          serviceTime: '2025-08-15 09:00-12:00',
          price: 128,
          status: '已完成',
          address: '成都市锦江区春熙路100号',
          createTime: '2025-08-14 15:30',
          completeTime: '2025-08-15 12:00'
        },
        {
          id: 2,
          serviceName: '日常保洁',
          serviceTime: '2025-07-18 14:00-16:00',
          price: 88,
          status: '已完成',
          address: '成都市武侯区天府大道200号',
          createTime: '2025-08-17 10:20',
          completeTime: '2025-08-18 16:00'
        },
        {
          id: 3,
          serviceName: '老人护理',
          serviceTime: '2025-06-20 08:00-18:00',
          price: 200,
          status: '已完成',
          address: '成都市青羊区宽窄巷子50号',
          createTime: '2025-06-19 09:15',
          completeTime: '2025-06-20 18:00'
        },
        {
          id: 4,
          serviceName: '家庭烹饪',
          serviceTime: '2025-05-22 17:00-19:00',
          price: 150,
          status: '已服务',
          address: '成都市高新区天府软件园',
          createTime: '2025-05-21 12:00',
          completeTime: '2025-05-22 19:00'
        },
        {
          id: 5,
          serviceName: '空调清洗',
          serviceTime: '2025-04-25 10:00-12:00',
          price: 120,
          status: '待评价',
          address: '成都市成华区建设路300号',
          createTime: '2025-04-24 14:30',
          completeTime: '2025-04-25 12:00'
        }
      ],
      // 评价数据
      reviews: [
        {
          id: 1,
          orderId: 1,
          serviceName: '深度清洁',
          serviceQuality: 5,
          serviceAttitude: 5,
          platformExperience: 4,
          comment: '服务非常专业，清洁效果很好，师傅态度也很好，会继续使用！',
          reviewTime: '2025-08-15 20:30'
        },
        {
          id: 2,
          orderId: 2,
          serviceName: '日常保洁',
          serviceQuality: 4,
          serviceAttitude: 5,
          platformExperience: 4,
          comment: '保洁师傅很细心，家里打扫得很干净，预约也很方便。',
          reviewTime: '2025-07-18 21:15'
        },
        {
          id: 3,
          orderId: 3,
          serviceName: '老人护理',
          serviceQuality: 5,
          serviceAttitude: 5,
          platformExperience: 5,
          comment: '护理员非常专业和耐心，对老人照顾得很周到，家人很放心。',
          reviewTime: '2025-06-20 22:00'
        },
        {
          id: 4,
          orderId: 6,
          serviceName: '月嫂服务',
          serviceQuality: 5,
          serviceAttitude: 5,
          platformExperience: 4,
          comment: '月嫂阿姨经验丰富，专业技能过硬，对宝宝和产妇都照顾得很好。特别是在母乳喂养指导和新生儿护理方面给了我们很大帮助，让我们这些新手父母安心不少。唯一小建议是希望平台的预约流程能更简化一些。',
          reviewTime: '2025-08-10 19:45'
        },
        {
          id: 5,
          orderId: 7,
          serviceName: '空调清洗',
          serviceQuality: 4,
          serviceAttitude: 4,
          platformExperience: 3,
          comment: '师傅很准时，清洗也很仔细，拆装过程很专业。清洗后空调制冷效果明显改善，异味也没有了。不过价格稍微有点贵，而且希望能提前告知需要准备的工具和材料。',
          reviewTime: '2025-07-28 16:20'
        },
        {
          id: 6,
          orderId: 8,
          serviceName: '下水道疏通',
          serviceQuality: 3,
          serviceAttitude: 4,
          platformExperience: 3,
          comment: '师傅态度不错，很快就解决了堵塞问题。但是疏通过程中有些脏水溅到了地面，希望下次能做好防护措施。整体服务还是满意的，就是收费标准希望能更透明一些。',
          reviewTime: '2025-07-05 14:30'
        },
        {
          id: 7,
          orderId: 9,
          serviceName: '油烟机清洗',
          serviceQuality: 5,
          serviceAttitude: 5,
          platformExperience: 5,
          comment: '非常满意的一次服务！师傅带了专业的清洗设备，把油烟机拆得很仔细，清洗得特别干净。安装回去后运行声音都小了很多。服务态度也很好，还教了我们日常保养的小技巧。',
          reviewTime: '2025-06-15 18:00'
        },
        {
          id: 8,
          orderId: 10,
          serviceName: '家庭烹饪',
          serviceQuality: 4,
          serviceAttitude: 5,
          platformExperience: 4,
          comment: '厨师手艺很好，做的菜品味道不错，营养搭配也很合理。特别是给孩子做的辅食很用心。就是希望能提供更多菜谱选择，价格也能再优惠一些就更好了。',
          reviewTime: '2025-05-22 20:10'
        }
      ],
      // 预约订单数据
      appointments: [
        {
          id: 1,
          serviceName: '月嫂服务',
          appointmentTime: '2025-03-28 08:00-20:00',
          address: '成都市锦江区东大街88号',
          status: '待服务',
          createTime: '2025-03-26 16:00'
        },
        {
          id: 2,
          serviceName: '深度清洁',
          appointmentTime: '2025-03-30 09:00-12:00',
          address: '成都市武侯区科华北路150号',
          status: '进行中',
          createTime: '2025-03-27 11:30'
        }
      ]
    };
  };

  // 模拟订单通知数据
  const [notifications] = useState([
    {
      id: 1,
      type: 'pending',
      title: '深度清洁服务',
      message: '您的订单已确认，服务人员将于明天上午9:00到达',
      time: '2025-02-20 14:30',
      status: '待服务'
    },
    {
      id: 2,
      type: 'completed',
      title: '日常保洁服务',
      message: '服务已完成，感谢您的使用',
      time: '2025-01-19 16:00',
      status: '已服务完成'
    },
    {
      id: 3,
      type: 'review',
      title: '老人护理服务',
      message: '服务已完成，请您对本次服务进行评价',
      time: '2025-04-18 18:30',
      status: '待评价'
    }
  ]);

  useEffect(() => {
    const stored = localStorage.getItem('housekeeping_user_info');
    if (stored) {
      try {
        const userInfo = JSON.parse(stored);
        setUser(userInfo);

        // 如果是测试账号，加载测试数据
        if (userInfo.phone === '13300000000') {
          loadTestData();
        }
      } catch {}
    }

    // 加载收藏夹数据
    const storedFavorites = localStorage.getItem('housekeeping_favorites');
    if (storedFavorites) {
      try { setFavorites(JSON.parse(storedFavorites)); } catch {}
    }
  }, []);

  // 加载测试数据函数
  const loadTestData = () => {
    const testData = getTestData();
    const DATA_VERSION = '2025.08.29.v2'; // 数据版本号

    // 检查数据版本，如果版本不匹配则重新加载数据
    const storedVersion = localStorage.getItem('housekeeping_data_version');
    const shouldReloadData = storedVersion !== DATA_VERSION;

    if (shouldReloadData) {
      // 清除旧数据并加载新数据
      localStorage.setItem('housekeeping_data_version', DATA_VERSION);
      localStorage.setItem('housekeeping_orders', JSON.stringify(testData.orders));
      localStorage.setItem('housekeeping_reviews', JSON.stringify(testData.reviews));
      localStorage.setItem('housekeeping_appointments', JSON.stringify(testData.appointments));

      setOrders(testData.orders);
      setReviews(testData.reviews);
      setAppointments(testData.appointments);
    } else {
      // 从localStorage加载现有数据
      const storedOrders = localStorage.getItem('housekeeping_orders');
      const storedReviews = localStorage.getItem('housekeeping_reviews');
      const storedAppointments = localStorage.getItem('housekeeping_appointments');

      if (storedOrders) {
        try { setOrders(JSON.parse(storedOrders)); } catch { setOrders(testData.orders); }
      } else {
        setOrders(testData.orders);
        localStorage.setItem('housekeeping_orders', JSON.stringify(testData.orders));
      }

      if (storedReviews) {
        try { setReviews(JSON.parse(storedReviews)); } catch { setReviews(testData.reviews); }
      } else {
        setReviews(testData.reviews);
        localStorage.setItem('housekeeping_reviews', JSON.stringify(testData.reviews));
      }

      if (storedAppointments) {
        try { setAppointments(JSON.parse(storedAppointments)); } catch { setAppointments(testData.appointments); }
      } else {
        setAppointments(testData.appointments);
        localStorage.setItem('housekeeping_appointments', JSON.stringify(testData.appointments));
      }
    }
  };

  // 预加载消费者权益保障与处理办法内容，确保点击时可全量显示
  useEffect(() => {
    let cancelled = false;
    setRightsLoading(true);
    fetch(consumerRightsUrl)
      .then(res => res.text())
      .then(text => { if (!cancelled) { setConsumerRightsContent(text); setRightsLoading(false); } })
      .catch(() => { if (!cancelled) { setRightsError('加载失败，请稍后重试'); setRightsLoading(false); } });
    return () => { cancelled = true; };
  }, []);

  const onLogin = async (e) => {
    e.preventDefault();
    if (!phoneReg.test(phone)) return alert('请输入正确的手机号');
    if (!password.trim()) return alert('请输入密码');

    // 验证测试账号
    if (phone === '13300000000' && password === '123456') {
      const u = { name: '张三', phone, address: '成都市锦江区春熙路100号', avatar: '👤' };
      setUser(u);
      localStorage.setItem('housekeeping_user_info', JSON.stringify(u));
      setShowLogin(false);
      setPassword('');
      setPhone('');

      // 加载测试数据
      loadTestData();
    } else {
      alert('手机号或密码错误，请使用测试账号：13300000000，密码：123456');
    }
  };

  // 处理键盘事件（ESC关闭模态框）
  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      if (showUserAgreementModal) {
        setShowUserAgreementModal(false);
      } else if (showConsumerRightsModal) {
        setShowConsumerRightsModal(false);
      } else if (showAboutModal) {
        setShowAboutModal(false);
      } else if (showNotificationModal) {
        setShowNotificationModal(false);
      } else if (showFavoritesModal) {
        setShowFavoritesModal(false);
      } else if (showReviewsModal) {
        setShowReviewsModal(false);
      } else if (showAppointmentsModal) {
        setShowAppointmentsModal(false);
      } else if (showReviewFormModal) {
        setShowReviewFormModal(false);
      }
    }
  };

  // 添加键盘事件监听
  React.useEffect(() => {
    if (showUserAgreementModal || showConsumerRightsModal ||
        showAboutModal || showNotificationModal || showFavoritesModal ||
        showReviewsModal || showAppointmentsModal || showReviewFormModal) {
      document.addEventListener('keydown', handleKeyDown);
      return () => document.removeEventListener('keydown', handleKeyDown);
    }
  }, [showUserAgreementModal, showConsumerRightsModal,
      showAboutModal, showNotificationModal, showFavoritesModal,
      showReviewsModal, showAppointmentsModal, showReviewFormModal]);

  const onLogout = () => {
    setUser(null);
    localStorage.removeItem('housekeeping_user_info');
  };

  // 收藏夹管理函数
  const toggleFavorite = (serviceId) => {
    const newFavorites = favorites.includes(serviceId)
      ? favorites.filter(id => id !== serviceId)
      : [...favorites, serviceId];

    setFavorites(newFavorites);
    localStorage.setItem('housekeeping_favorites', JSON.stringify(newFavorites));
  };

  const getFavoriteServices = () => {
    return services.filter(service => favorites.includes(service.id));
  };

  // 订单状态管理函数
  const confirmOrder = (orderId) => {
    const updatedOrders = orders.map(order =>
      order.id === orderId ? { ...order, status: '待评价' } : order
    );
    setOrders(updatedOrders);
    localStorage.setItem('housekeeping_orders', JSON.stringify(updatedOrders));
  };

  const openReviewForm = (order) => {
    setCurrentReviewOrder(order);
    setShowReviewFormModal(true);
  };

  // 提交评价函数
  const submitReview = (reviewData) => {
    const newReview = {
      id: reviews.length + 1,
      orderId: currentReviewOrder.id,
      serviceName: currentReviewOrder.serviceName,
      ...reviewData,
      reviewTime: new Date().toLocaleString('zh-CN')
    };

    const updatedReviews = [...reviews, newReview];
    setReviews(updatedReviews);
    localStorage.setItem('housekeeping_reviews', JSON.stringify(updatedReviews));

    // 更新订单状态为已完成
    const updatedOrders = orders.map(order =>
      order.id === currentReviewOrder.id ? { ...order, status: '已完成' } : order
    );
    setOrders(updatedOrders);
    localStorage.setItem('housekeeping_orders', JSON.stringify(updatedOrders));

    setShowReviewFormModal(false);
    setCurrentReviewOrder(null);
    alert('评价提交成功！');
  };

  return (
    <div className="my-page">
      <header className="my-header">
        <Link to="/" className="back-btn">← 返回</Link>
        <h1>我的</h1>
      </header>

      <div className="container">
        {!user ? (
          <div className="card login-card">
            {!showLogin ? (
              <div className="login-intro">
                <div className="intro-title">欢迎登录</div>
                <p className="intro-text">登录后可查看和管理您的个人信息与订单</p>
                <button className="btn" onClick={() => setShowLogin(true)}>用户登录</button>
              </div>
            ) : (
              <form className="login-form" onSubmit={onLogin}>
                <div className="form-group">
                  <label>手机号</label>
                  <input type="tel" value={phone} onChange={(e)=>setPhone(e.target.value)} placeholder="请输入手机号" required />
                </div>
                <div className="form-group">
                  <label>密码</label>
                  <input type="password" value={password} onChange={(e)=>setPassword(e.target.value)} placeholder="请输入密码" required />
                </div>
                <button type="submit" className="btn submit">登录</button>
              </form>
            )}
          </div>
        ) : (
          <>
            <div className="user-info-card">
              <div className="user-avatar">{user.avatar}</div>
              <div className="user-details">
                <h2>{user.name}</h2>
                <p>{user.phone}</p>
                <p>{user.address}</p>
              </div>
              <button className="edit-btn" onClick={onLogout}>退出登录</button>
            </div>

            {/* 新增：VIP 会员权益横幅 */}
            <div className="vip-banner" onClick={() => navigate('/membership-package')}>
                 <div className="vip-content">
                    <div className="vip-left">
                        <span className="vip-icon">👑</span>
                        <div>
                            <h3 className="vip-title">开通联合会员</h3>
                            <p className="vip-desc">低至 ¥29.9/月 · 享视频会员+生活权益</p>
                        </div>
                    </div>
                    <div className="vip-action">
                        <span>立即开通</span>
                        <span className="vip-arrow">→</span>
                    </div>
                 </div>
            </div>

            <div className="menu-section">
              <h3>我的服务</h3>
              <div className="menu-list">
                <div className="menu-item" onClick={() => setShowAppointmentsModal(true)}>
                  <span>我的预约</span><span className="arrow">›</span>
                </div>
                <div className="menu-item" onClick={() => setShowReviewsModal(true)}>
                  <span>服务评价</span><span className="arrow">›</span>
                </div>
                <div className="menu-item" onClick={() => setShowFavoritesModal(true)}>
                  <span>收藏夹</span><span className="arrow">›</span>
                </div>
              </div>
            </div>

            <div className="orders-section">
              <h3>最近订单</h3>
              <div className="orders-list">
                {orders.slice(0, 3).map(order => (
                  <div key={order.id} className={`order-item ${order.rights ? 'membership-card' : ''}`}>
                    <div className="order-info">
                      <h4>
                          {order.serviceName}
                          {order.rights && <span className="tag-vip-badge">自动续费</span>}
                      </h4>
                      {order.rights ? (
                         <div className="order-rights-summary">
                            {order.rights.map((r, idx) => (
                                <div key={idx} className="right-tag">
                                    <span className="dot"></span>{r}
                                </div>
                            ))}
                         </div>
                      ) : (
                         <p>{order.serviceTime}</p>
                      )}
                      
                      {!order.rights && <p className="order-price">¥{order.price}</p>}
                      {order.rights && <p className="order-price" style={{marginTop: '8px', color: '#bfa05f', fontWeight: 'bold'}}>¥{order.price}<span style={{fontSize:'12px', fontWeight:'normal'}}>/月</span></p>}
                    </div>
                    <div className="order-actions">
                      <div className={`order-status status-${order.status === '已完成' ? 'completed' :
                                                            order.status === '已服务' ? 'served' :
                                                            order.status === '待评价' ? 'review' : 
                                                            order.status === '已生效' ? 'vip-active' : 'pending'}`}>
                        {order.status}
                      </div>
                      {order.status === '已服务' && (
                        <button
                          className="action-btn confirm-btn"
                          onClick={() => confirmOrder(order.id)}
                        >
                          确认收货
                        </button>
                      )}
                      {order.status === '待评价' && (
                        <button
                          className="action-btn review-btn"
                          onClick={() => openReviewForm(order)}
                        >
                          去评价
                        </button>
                      )}
                      {order.rights && (
                           <button 
                                className="action-btn btn-vip-redeem" 
                                onClick={() => navigate('/member-rights', { state: { order } })}
                           >
                               前往领取
                               <span className="arrow">→</span>
                           </button>
                      )}
                    </div>
                  </div>
                ))}
                {orders.length === 0 && (
                  <div className="empty-orders">
                    <p>暂无订单记录</p>
                  </div>
                )}
              </div>
            </div>

            <div className="menu-section">
              <h3>设置</h3>
              <div className="menu-list">
                <div className="menu-item" onClick={() => setShowNotificationModal(true)}>
                  <span>消息通知</span><span className="arrow">›</span>
                </div>
                <div className="menu-item" onClick={() => setShowAboutModal(true)}>
                  <span>关于我们</span><span className="arrow">›</span>
                </div>
                <div className="menu-item" onClick={() => navigate('/customer-service')}>
                  <span>联系客服</span><span className="arrow">›</span>
                </div>
              </div>
            </div>
          </>
        )}

        {/* 消费者权益与用户协议 */}
        <div className="user-agreement-link">
          <button
            className="agreement-link-btn"
            onClick={() => setShowUserAgreementModal(true)}
          >
            用户协议
          </button>
          <button
            className="agreement-link-btn"
            onClick={() => setShowConsumerRightsModal(true)}
            style={{ marginLeft: 12 }}
          >
            消费者权益保障与处理办法
          </button>
        </div>
      </div>



      {/* 用户协议模态框 */}
      {showUserAgreementModal && (
        <div className="modal-overlay" onClick={() => setShowUserAgreementModal(false)}>
          <div className="modal-content user-agreement-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>用户协议</h2>
              <button
                className="modal-close"
                onClick={() => setShowUserAgreementModal(false)}
                aria-label="关闭"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="user-agreement-content">
                {USER_AGREEMENT_CONTENT.split(/(?=[一二三四五六七八九十]、)|(?=支付5\.1)|(?=通知和送达12\.1)|(?=十三、其他)/).map((section, index) => {
                  if (section.trim() === '') return null;

                  // 检查是否是主要标题
                  const isMainTitle = /^[一二三四五六七八九十]、/.test(section.trim()) ||
                                     /^支付5\.1/.test(section.trim()) ||
                                     /^通知和送达12\.1/.test(section.trim()) ||
                                     /^十三、其他/.test(section.trim());

                  if (isMainTitle) {
                    // 进一步分割子内容
                    const parts = section.split(/(?=\d+\.\d+)/).filter(part => part.trim() !== '');


                    return (
                      <div key={index}>
                        {parts.map((part, partIndex) => {
                          const isSubTitle = /^\d+\.\d+/.test(part.trim());
                          return (
                            <div key={`${index}-${partIndex}`}
                                 className={partIndex === 0 ? 'agreement-section-title' :
                                           isSubTitle ? 'agreement-subsection-title' : 'agreement-section-content'}>
                              {part.trim()}
                            </div>
                          );
                        })}
                      </div>
                    );
                  } else {
                    return (
                      <div key={index} className="agreement-section-content">
                        {section.trim()}
                      </div>
                    );
                  }
                })}
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn modal-btn"
                onClick={() => setShowUserAgreementModal(false)}
              >
                关闭
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 消费者权益保障与处理办法 模态框 */}
      {showConsumerRightsModal && (
        <div className="modal-overlay" onClick={() => setShowConsumerRightsModal(false)}>
          <div className="modal-content user-agreement-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>消费者权益保障与处理办法</h2>
              <button
                className="modal-close"
                onClick={() => setShowConsumerRightsModal(false)}
                aria-label="关闭"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              <div className="user-agreement-content" style={{ whiteSpace: 'pre-wrap' }}>
                {rightsLoading ? (
                  <p>加载中...</p>
                ) : rightsError ? (
                  <p className="error-text">{rightsError}</p>
                ) : (
                  consumerRightsContent.split('\n').map((line, idx) => (
                    <p key={idx} className={line.trim() === '' ? 'empty-line' : ''}>{line}</p>
                  ))
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn modal-btn"
                onClick={() => setShowConsumerRightsModal(false)}
              >
                关闭
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 关于我们模态框 */}
      {showAboutModal && (
        <div className="modal-overlay" onClick={() => setShowAboutModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>关于我们</h3>
              <button className="modal-close" onClick={() => setShowAboutModal(false)}>×</button>
            </div>
            <div className="modal-body">
              <div className="about-content">
                <h4>益美科技家政服务 v1.0</h4>
                <p><strong>运营单位：</strong>成都益美美佳网络科技有限公司</p>
                <p><strong>客服电话：</strong>028-60786646</p>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={() => setShowAboutModal(false)}>
                确定
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 消息通知模态框 */}
      {showNotificationModal && (
        <div className="modal-overlay" onClick={() => setShowNotificationModal(false)}>
          <div className="modal-content notification-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>消息通知</h3>
              <button className="modal-close" onClick={() => setShowNotificationModal(false)}>×</button>
            </div>
            <div className="modal-body">
              <div className="notification-list">
                {notifications.map(notification => (
                  <div key={notification.id} className={`notification-item ${notification.type}`}>
                    <div className="notification-header">
                      <h4>{notification.title}</h4>
                      <span className={`status-badge status-${notification.type}`}>
                        {notification.status}
                      </span>
                    </div>
                    <p className="notification-message">{notification.message}</p>
                    <p className="notification-time">{notification.time}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={() => setShowNotificationModal(false)}>
                关闭
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 收藏夹模态框 */}
      {showFavoritesModal && (
        <div className="modal-overlay" onClick={() => setShowFavoritesModal(false)}>
          <div className="modal-content favorites-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>我的收藏</h3>
              <button className="modal-close" onClick={() => setShowFavoritesModal(false)}>×</button>
            </div>
            <div className="modal-body">
              <div className="favorites-list">
                {getFavoriteServices().length === 0 ? (
                  <div className="empty-favorites">
                    <p>暂无收藏的服务</p>
                    <p className="empty-tip">在服务页面点击爱心图标即可收藏服务</p>
                  </div>
                ) : (
                  getFavoriteServices().map(service => (
                    <div
                      key={service.id}
                      className="favorite-item clickable"
                      onClick={() => {
                        setShowFavoritesModal(false);
                        navigate(`/detail?serviceId=${service.id}`);
                      }}
                    >
                      <img src={service.image} alt={service.name} className="favorite-image" />
                      <div className="favorite-info">
                        <h4>{service.name}</h4>
                        <p className="favorite-description">
                          {service.description.slice(0, 60)}...
                        </p>
                        <div className="favorite-details">
                          <span className="favorite-price">¥{service.price}</span>
                          <span className="favorite-duration">{service.duration}</span>
                        </div>
                      </div>
                      <div className="favorite-actions">
                        <button
                          className="unfavorite-btn"
                          onClick={(e) => {
                            e.stopPropagation(); // 阻止事件冒泡
                            toggleFavorite(service.id);
                          }}
                          title="取消收藏"
                        >
                          💔
                        </button>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={() => setShowFavoritesModal(false)}>
                关闭
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 服务评价模态框 */}
      {showReviewsModal && (
        <div className="modal-overlay" onClick={() => setShowReviewsModal(false)}>
          <div className="modal-content reviews-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>我的评价</h3>
              <button className="modal-close" onClick={() => setShowReviewsModal(false)}>×</button>
            </div>
            <div className="modal-body">
              <div className="reviews-list">
                {reviews.length === 0 ? (
                  <div className="empty-reviews">
                    <p>暂无评价记录</p>
                    <p className="empty-tip">完成服务后可以进行评价</p>
                  </div>
                ) : (
                  reviews.map(review => (
                    <ReviewItem key={review.id} review={review} />
                  ))
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={() => setShowReviewsModal(false)}>
                关闭
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 我的预约模态框 */}
      {showAppointmentsModal && (
        <div className="modal-overlay" onClick={() => setShowAppointmentsModal(false)}>
          <div className="modal-content appointments-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>我的预约</h3>
              <button className="modal-close" onClick={() => setShowAppointmentsModal(false)}>×</button>
            </div>
            <div className="modal-body">
              <div className="appointments-list">
                {appointments.length === 0 ? (
                  <div className="empty-appointments">
                    <p>暂无预约订单</p>
                    <p className="empty-tip">您可以在服务页面预约需要的服务</p>
                  </div>
                ) : (
                  appointments.map(appointment => (
                    <div key={appointment.id} className="appointment-item">
                      <div className="appointment-header">
                        <h4>{appointment.serviceName}</h4>
                        <span className={`appointment-status status-${appointment.status === '待服务' ? 'pending' : 'progress'}`}>
                          {appointment.status}
                        </span>
                      </div>
                      <div className="appointment-details">
                        <p><strong>预约时间：</strong>{appointment.appointmentTime}</p>
                        <p><strong>服务地址：</strong>{appointment.address}</p>
                        <p><strong>预约时间：</strong>{appointment.createTime}</p>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={() => setShowAppointmentsModal(false)}>
                关闭
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 评价表单模态框 */}
      {showReviewFormModal && currentReviewOrder && (
        <ReviewFormModal
          order={currentReviewOrder}
          onSubmit={submitReview}
          onClose={() => {
            setShowReviewFormModal(false);
            setCurrentReviewOrder(null);
          }}
        />
      )}

    </div>
  );
};

// 评价表单组件
const ReviewFormModal = ({ order, onSubmit, onClose }) => {
  const [serviceQuality, setServiceQuality] = useState(5);
  const [serviceAttitude, setServiceAttitude] = useState(5);
  const [platformExperience, setPlatformExperience] = useState(5);
  const [comment, setComment] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!comment.trim()) {
      alert('请填写评价内容');
      return;
    }

    onSubmit({
      serviceQuality,
      serviceAttitude,
      platformExperience,
      comment: comment.trim()
    });
  };

  const StarRating = ({ value, onChange, label }) => (
    <div className="rating-row">
      <span className="rating-label">{label}：</span>
      <div className="star-selector">
        {[1,2,3,4,5].map(star => (
          <button
            key={star}
            type="button"
            className={`star-btn ${star <= value ? 'active' : ''}`}
            onClick={() => onChange(star)}
          >
            ★
          </button>
        ))}
      </div>
    </div>
  );

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content review-form-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>评价服务</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="service-info">
              <h4>{order.serviceName}</h4>
              <p>服务时间：{order.serviceTime}</p>
            </div>

            <div className="rating-section">
              <StarRating
                value={serviceQuality}
                onChange={setServiceQuality}
                label="服务质量"
              />
              <StarRating
                value={serviceAttitude}
                onChange={setServiceAttitude}
                label="服务态度"
              />
              <StarRating
                value={platformExperience}
                onChange={setPlatformExperience}
                label="平台体验"
              />
            </div>

            <div className="comment-section">
              <label>评价内容：</label>
              <textarea
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="请分享您的服务体验..."
                rows={4}
                required
              />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              取消
            </button>
            <button type="submit" className="btn btn-primary">
              提交评价
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// 评价项组件
const ReviewItem = ({ review }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = 100; // 最大显示字符数
  const shouldTruncate = review.comment.length > maxLength;

  // 获取星级颜色
  const getStarColor = (rating) => {
    if (rating >= 5) return '#fbbf24'; // 金色
    if (rating >= 4) return '#3b82f6'; // 蓝色
    return '#f97316'; // 橙色
  };

  // 格式化时间显示
  const formatTime = (timeString) => {
    const date = new Date(timeString);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 1) return '昨天';
    if (diffDays <= 7) return `${diffDays}天前`;
    if (diffDays <= 30) return `${Math.ceil(diffDays / 7)}周前`;
    return timeString.split(' ')[0]; // 显示日期部分
  };

  const StarRating = ({ rating, label }) => (
    <div className="rating-item">
      <span className="rating-label">{label}：</span>
      <div className="stars">
        {[1,2,3,4,5].map(star => (
          <span
            key={star}
            className={star <= rating ? 'star filled' : 'star'}
            style={{ color: star <= rating ? getStarColor(rating) : '#e5e7eb' }}
          >
            ★
          </span>
        ))}
        <span className="rating-score">({rating}分)</span>
      </div>
    </div>
  );

  return (
    <div className="review-item">
      <div className="review-header">
        <h4>{review.serviceName}</h4>
        <span className="review-time">{formatTime(review.reviewTime)}</span>
      </div>
      <div className="review-ratings">
        <StarRating rating={review.serviceQuality} label="服务质量" />
        <StarRating rating={review.serviceAttitude} label="服务态度" />
        <StarRating rating={review.platformExperience} label="平台体验" />
      </div>
      <div className="review-comment">
        <p>
          {shouldTruncate && !isExpanded
            ? `${review.comment.slice(0, maxLength)}...`
            : review.comment
          }
        </p>
        {shouldTruncate && (
          <button
            className="expand-btn"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? '收起' : '展开'}
          </button>
        )}
      </div>
    </div>
  );
};

export default MyPage;


